<template>
  <div class="columns is-multiline">
    <!--Left-->
    <div class="column is-12">
      <p class="title is-5">
        Left Column
        <b-button @click="addRow('L')" type="is-success" size="is-small" icon-left="plus"></b-button>
      </p>
      <b-collapse class="card" animation="slide"
        v-for="(left_match_row, lindex) of matching.left" :key="`L${lindex}`"
        :open="isLeftOpen == lindex" @open="isLeftOpen = lindex">
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ left_match_row.title ? left_match_row.title : `LO${lindex+1}` }}</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content">
            <set-clipart-layer :key="`MATCHL_${lindex}_CLIP_LAYER`" :show_track_count="true" :show_add_remove="true" v-model="left_match_row.layers"></set-clipart-layer>
            <b-field label="Title">
              <b-input v-model="left_match_row.title" expanded></b-input>
            </b-field>
            <style-editor show_font_color show_font_size show_text_align v-model="left_match_row.styles" :key="`MATCHL_${lindex}_STYLES`" />
            <b-button @click="removeRow('L', lindex)" type="is-danger" size="is-small" icon-left="close"></b-button>
          </div>
        </div>
      </b-collapse>
    </div>

    <!--Right-->
    <div class="column is-12">
      <p class="title is-5">
        Right Column
        <b-button @click="addRow('R')" type="is-success" size="is-small" icon-left="plus"></b-button>
      </p>
      <b-collapse class="card" animation="slide"
        v-for="(right_match_row, rindex) of matching.right" :key="`R${rindex}`"
        :open="isRightOpen == rindex" @open="isRightOpen = rindex">
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ right_match_row.title ? right_match_row.title : `RO${rindex+1}` }}</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content">
            <set-clipart-layer :key="`MATCHR_${rindex}_CLIP_LAYER`" :show_track_count="true" :show_add_remove="true" v-model="right_match_row.layers"></set-clipart-layer>
            <b-field label="Title">
              <b-input v-model="right_match_row.title" expanded></b-input>
            </b-field>
            <style-editor show_font_color show_font_size show_text_align v-model="right_match_row.styles" :key="`MATCHR_${rindex}_STYLES`" />
            <b-button @click="removeRow('R', rindex)" type="is-danger" size="is-small" icon-left="close"></b-button>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="column is-4">
      <p class="title is-5">
        Answers
        <b-button @click="addAnswerRow()" type="is-success" size="is-small" icon-left="plus"></b-button>
      </p>
      <b-table v-if="matching.answers" :data="matching.answers">
        <b-table-column field="left" label="Left" v-slot="props">
          <b-select v-model="props.row.left" expanded>
            <option v-for="(left_row, left_row_i) in matching.left" :key="`LO-${left_row_i}`" :value="left_row_i">{{left_row.title ? left_row.title : `LO${left_row_i+1}`}}</option>
          </b-select>
        </b-table-column>
        <b-table-column field="right" label="Right" v-slot="props">
          <b-select v-model="props.row.right" expanded>
            <option v-for="(right_row, right_row_i) in matching.right" :key="`RO-${right_row_i}`" :value="right_row_i">{{right_row.title ? right_row.title : `RO${right_row_i+1}`}}</option>
          </b-select>
        </b-table-column>
        <b-table-column field="action" label="Action" v-slot="props">
          <b-button @click="removeAnswerRow(props.index)" size="is-small" type="is-danger" icon-left="close"></b-button>
        </b-table-column>
      </b-table>
    </div>
    <div class="column is-8">
      <show-matching :matching="matching"></show-matching>
    </div>
  </div>
</template>
<script>
import SetClipartLayer from "@/components/Question/SetClipartLayer"
import ShowMatching from './ShowMatching.vue'
import StyleEditor from '@/components/Common/StyleEditor/StyleEditor.vue'
import {defaultMatchingValue, defaultMatchingRowValue} from './utils'

export default {
  name : 'set-matching',
  components: {
    SetClipartLayer,
    ShowMatching,
    StyleEditor,
  },
  props : {
    value : {
      type : Object
    }
  },
  data(){
    return {
      isLeftOpen : null,
      isRightOpen : null,
      matching : this.value ? this.value : defaultMatchingValue(),
    }
  },
  methods : {
    addRow(type){
      if(type == 'R'){
        this.matching.right.push(defaultMatchingRowValue())
      }else if(type == 'L'){
        this.matching.left.push(defaultMatchingRowValue())
      }
    },
    addAnswerRow(){
      this.matching.answers.push({
        left : null,
        right : null
      })
    },
    removeRow(type, index){
      if(type == 'R'){
        this.matching.right.splice(index, 1)
      }else if(type == 'L'){
        this.matching.left.splice(index, 1)
      }
    },
    removeAnswerRow(index){
      this.matching.answers.splice(index, 1)
    }
  },
  watch : {
    value : {
      handler : function(new_val){
        this.matching = new_val
      },
      deep : true
    },
    matching : {
      handler : function(new_val){
        this.$emit('input', new_val)
      },
      deep : true
    }
  },
  created(){

  }
}
</script>
<style scoped></style>